import {BaseService} from "./base.service";

class NotificactionsService extends BaseService {

    allNotifications() {
        //EL ROLE ID DEBE SER 0,8,9 QUE SON EL CONTRATANTE, AFILIADO T Y D
        return this.http.get(`api/all-notifications`).then(response => response.data).catch(err => err.message);
    }

    unreadNotifications() {
        //EL ROLE ID DEBE SER 0,8,9 QUE SON EL CONTRATANTE, AFILIADO T Y D
        return this.http.get(`api/unread-notifications`).then(response => response.data).catch(err => err.message);
    }

    readNotifications() {
        //EL ROLE ID DEBE SER 0,8,9 QUE SON EL CONTRATANTE, AFILIADO T Y D
        return this.http.get(`api/read-notifications`).then(response => response.data).catch(err => err.message);
    }

    markAsRead(id) {
        return this.http.get(`api/mark-as-read/${id}`).then(response => response.data).catch(err => err.message);
    }

}

export const notificationsService = new NotificactionsService();
